export const moveToADifferentFolder = "cxc";
export default {moveToADifferentFolder};